import React from 'react';
import PandaSignImg from '../../assets/images/panda_sign.png';

interface PandaSignProps {
    message: string;
    style?: React.CSSProperties;
}

export const PandaSign = ({ message, style = {} }: PandaSignProps) => {
  if (!message) {return null;}

  return (
    <div>
      <div
        style={{
          ...style,
          maxWidth: '200px', 
          height: 'auto',
          position: 'relative',
        }}
      >
        <img
          src={PandaSignImg}
          alt="Panda with sign"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            margin: '0 auto',
          }}
        />

        <div
          style={{
            position: 'absolute',
            top: '-65px',     
            left: '-75px',   
            transform: 'rotate(-10deg)',
            backgroundColor: '#ceb076',
            border: '5px solid #bc9444',
            borderRadius: '8px',
            padding: '8px 12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            zIndex: 100,
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            maxWidth: '120px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          }}
        >
       
          {message}
        </div>
      </div>
    </div>
  );
};